module.exports = __webpack_public_path__ + "img/32.9f009446.jpg";